// const server = "http://localhost";
// const domain = "localhost";
// const port = 9358;
const serverImg = 'https://msgarquitectos.nbg1.your-objectstorage.com/public';
const server = "https://apimsgarquitectos.mansolutions.app";
const port = 443;
const domain = "msgarquitectos.mansolutions.app";
export { server, port, domain, serverImg };
